import * as h2Api from '../h2Api'

export const FETCH_IGP_DATA = 'FETCH_IGP_DATA'

// -------------------- Action Creators

export const fetchIGPData = () => h2Api.get('/user/igp')({ type: FETCH_IGP_DATA })
